import {Icons} from '@material-table/core'
import {
    AddBox,
    ArrowDownward,
    Check,
    ChevronLeft,
    ChevronRight,
    Clear,
    DeleteOutline,
    Edit,
    FilterList,
    FirstPage,
    Publish,
    LastPage,
    Remove,
    Search,
    ViewColumn,
    Refresh,
    Palette,
    GetApp,
    VisibilityOffOutlined,
    VisibilityOff,
    Visibility,
    CloudUpload
} from '@mui/icons-material'
import {SvgIconOwnProps} from '@mui/material'
import {forwardRef} from 'react'

const materialTableIcons = {
    Add: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <AddBox data-cy="material-table-add" {...props} ref={ref} />
    )),
    Check: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <Check data-cy="material-table-check" {...props} ref={ref} />
    )),
    Clear: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <Clear data-cy="material-table-clear" {...props} ref={ref} />
    )),
    ColourPalette: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <Palette data-cy="material-table-palette" {...props} ref={ref} />
    )),
    Delete: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <DeleteOutline data-cy="material-table-delete" {...props} ref={ref} />
    )),
    DetailPanel: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <ChevronRight data-cy="material-table-detail" {...props} ref={ref} />
    )),
    Edit: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <Edit data-cy="material-table-edit" {...props} ref={ref} />
    )),
    Export: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <Publish data-cy="material-table-export" {...props} ref={ref} />
    )),
    Import: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <GetApp data-cy="material-table-import" {...props} ref={ref} />
    )),
    Filter: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <FilterList data-cy="material-table-filter" {...props} ref={ref} />
    )),
    FirstPage: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <FirstPage data-cy="material-table-first-page" {...props} ref={ref} />
    )),
    LastPage: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <LastPage data-cy="material-table-last-page" {...props} ref={ref} />
    )),
    NextPage: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <ChevronRight data-cy="material-table-next-page" {...props} ref={ref} />
    )),
    PreviousPage: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <ChevronLeft data-cy="material-table-previous-page" {...props} ref={ref} />
    )),
    ResetSearch: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <Clear data-cy="material-table-clear-search" {...props} ref={ref} />
    )),
    Retry: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <Refresh data-cy="material-table-retry" {...props} ref={ref} />
    )),
    Search: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <Search data-cy="material-table-search" {...props} ref={ref} />
    )),
    SortArrow: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <ArrowDownward data-cy="material-table-sort" {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <Remove data-cy="material-table-third-state-check" {...props} ref={ref} />
    )),
    Upload: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <CloudUpload data-cy="material-table-upload" {...props} ref={ref} />
    )),
    ViewColumn: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <ViewColumn data-cy="material-table-view-column" {...props} ref={ref} />
    )),
    Visibility: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <Visibility data-cy="material-table-visibility" {...props} ref={ref} />
    )),
    VisibilityOff: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <VisibilityOff data-cy="material-table-visibility-off" {...props} ref={ref} />
    )),
    VisibilityOffOutlined: forwardRef<SVGSVGElement, SvgIconOwnProps>((props, ref) => (
        <VisibilityOffOutlined data-cy="material-table-visibility-off-outlined" {...props} ref={ref} />
    ))
} satisfies Record<string, Icons<never>['Add']>

export default materialTableIcons
